document.addEventListener('DOMContentLoaded', () => {
  // Initialize the store locator functionality
  initializeStoreLocator();
});

function initializeStoreLocator() {
  const form = document.getElementById('store-locator-form');
  const multiselectDisplay = document.getElementById('multiselect-display');
  const multiselectDropdown = document.getElementById('multiselect-dropdown');
  const cityInput = document.getElementById('city-input');
  const stateInput = document.getElementById('state-input');
  const zipInput = document.getElementById('zip-input');
  const findButton = document.getElementById('find-stores-btn');
  const resultsContainer = document.getElementById('store-results');

  // Mapbox configuration
  const MAPBOX_TOKEN = 'pk.eyJ1IjoibGl2ZWx5LW1hcGJveCIsImEiOiJjbWcwenhtN2gwZXF4MnJyMDg1YWRvbTF1In0.exNYDwvexxt1xE-ONguBDA';
  let map = null;
  let markers = [];

  if (!form || !multiselectDisplay || !multiselectDropdown) {
    return;
  }

  // Initialize multiselect functionality
  initializeMultiselect();

  // Initialize Florida map on page load
  initializeFloridaMap();

  // Handle form submission
  form.addEventListener('submit', handleFormSubmit);

  // Clear zip when city/state is entered and vice versa
  cityInput.addEventListener('input', () => {
    if (cityInput.value.trim()) {
      zipInput.value = '';
    }
  });

  stateInput.addEventListener('input', () => {
    if (stateInput.value.trim()) {
      zipInput.value = '';
    }
  });

  zipInput.addEventListener('input', () => {
    if (zipInput.value.trim()) {
      cityInput.value = '';
      stateInput.value = '';
    }
  });

  function initializeMultiselect() {
    const checkboxes = multiselectDropdown.querySelectorAll('input[type="checkbox"]');
    
    // Make multiselect display focusable and keyboard accessible
    multiselectDisplay.setAttribute('tabindex', '0');
    multiselectDisplay.setAttribute('role', 'combobox');
    multiselectDisplay.setAttribute('aria-expanded', 'false');
    multiselectDisplay.setAttribute('aria-haspopup', 'listbox');
    
    // Handle multiselect display click and keyboard
    const handleDisplayInteraction = (e) => {
      if (e.type === 'click' || e.key === 'Enter' || e.key === ' ' || e.keyCode === 32 || e.keyCode === 13) {
        if (e.type === 'keydown') {
          e.preventDefault(); // Prevent page scroll on space
        }
        toggleDropdown();
      }
    };
    
    multiselectDisplay.addEventListener('click', handleDisplayInteraction);
    multiselectDisplay.addEventListener('keydown', handleDisplayInteraction);

    // Handle checkbox changes
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', updateSelectedItems);
    });

    // Handle multiselect option clicks (entire option area)
    const multiselectOptions = multiselectDropdown.querySelectorAll('.multiselect-option');
    multiselectOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        // Don't trigger if clicking directly on checkbox or label (they handle themselves)
        if (e.target.type === 'checkbox' || e.target.tagName === 'LABEL') {
          return;
        }
        
        // Find the checkbox within this option and toggle it
        const checkbox = option.querySelector('input[type="checkbox"]');
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          updateSelectedItems();
        }
      });
    });

    // Close dropdown when clicking outside or pressing Escape
    const handleOutsideClick = (e) => {
      if (!multiselectDisplay.contains(e.target) && !multiselectDropdown.contains(e.target)) {
        closeDropdown();
      }
    };
    
    const handleEscape = (e) => {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeDropdown();
        multiselectDisplay.focus();
      }
    };
    
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('keydown', handleEscape);
    
    // Cleanup event listeners when component is destroyed
    return () => {
      document.removeEventListener('click', handleOutsideClick);
      document.removeEventListener('keydown', handleEscape);
      multiselectDisplay.removeEventListener('keydown', handleDisplayInteraction);
    };

    // Initialize display
    updateSelectedItems();
  }

  function initializeFloridaMap() {
    // Set Mapbox access token
    mapboxgl.accessToken = MAPBOX_TOKEN;

    // Determine which map container to use based on screen size
    const isMobile = window.innerWidth <= 767;
    const mapContainer = isMobile ? 'mobile-map' : 'store-map';
    
    // Make sure the appropriate container is visible
    if (isMobile) {
      document.querySelector('.mobile-map-container').style.display = 'block';
    }

    // Initialize empty map centered on Florida
    map = new mapboxgl.Map({
      container: mapContainer,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [-82.4572, 27.7663], // Florida center coordinates
      zoom: 6 // Show most of Florida
    });

    // Add navigation controls
    map.addControl(new mapboxgl.NavigationControl(), 'top-right');
  }

  function toggleDropdown() {
    const isActive = multiselectDropdown.classList.contains('active');
    if (isActive) {
      closeDropdown();
    } else {
      openDropdown();
    }
  }

  function openDropdown() {
    multiselectDropdown.classList.add('active');
    multiselectDisplay.classList.add('active');
  }

  function closeDropdown() {
    multiselectDropdown.classList.remove('active');
    multiselectDisplay.classList.remove('active');
  }

  function updateSelectedItems() {
    const checkboxes = multiselectDropdown.querySelectorAll('input[type="checkbox"]:checked');
    const selectedItems = Array.from(checkboxes).map(cb => ({
      value: cb.value,
      label: cb.nextElementSibling.textContent
    }));

    // Update the display
    const placeholder = multiselectDisplay.querySelector('.placeholder');
    let selectedItemsContainer = multiselectDisplay.querySelector('.selected-items');

    if (selectedItems.length === 0) {
      // Show placeholder
      if (placeholder) {
        placeholder.style.display = 'block';
      }
      if (selectedItemsContainer) {
        selectedItemsContainer.remove();
      }
    } else {
      // Hide placeholder and show selected items
      if (placeholder) {
        placeholder.style.display = 'none';
      }

      if (!selectedItemsContainer) {
        selectedItemsContainer = document.createElement('div');
        selectedItemsContainer.className = 'selected-items';
        multiselectDisplay.appendChild(selectedItemsContainer);
      }

      selectedItemsContainer.innerHTML = selectedItems.map(item => `
        <span class="selected-item">
          ${item.label}
          <span class="remove" data-value="${item.value}">×</span>
        </span>
      `).join('');

      // Handle remove clicks
      selectedItemsContainer.querySelectorAll('.remove').forEach(removeBtn => {
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          const value = e.target.getAttribute('data-value');
          const checkbox = multiselectDropdown.querySelector(`input[value="${value}"]`);
          if (checkbox) {
            checkbox.checked = false;
            updateSelectedItems();
          }
        });
      });
    }
  }

  async function handleFormSubmit(e) {
    e.preventDefault();

    // Get selected devices
    const selectedDevices = Array.from(multiselectDropdown.querySelectorAll('input[type="checkbox"]:checked'))
      .map(cb => cb.value);

    if (selectedDevices.length === 0) {
      showError('Please select at least one device.');
      return;
    }

    // Get location data
    const city = cityInput.value.trim();
    const state = stateInput.value.trim();
    const zip = zipInput.value.trim();

    // Validate location input
    if (!zip && (!city || !state)) {
      showError('Please enter either a ZIP code or both City and State.');
      return;
    }

    if (zip && (city || state)) {
      showError('Please enter either ZIP code OR City and State, not both.');
      return;
    }

    // Show loading state
    showLoading();

    try {
      // Build API URL
      const baseUrl = 'https://api.lively.com/v1/location/nearest-stores';
      
      let apiUrl;
      if (zip) {
        apiUrl = `${baseUrl}?PostalCode=${encodeURIComponent(zip)}`;
      } else {
        apiUrl = `${baseUrl}?City=${encodeURIComponent(city)}&RegionCode=${encodeURIComponent(state)}`;
      }
      console.log(apiUrl)
      
      // Add ProductShortNames as separate parameters
      selectedDevices.forEach(device => {
        apiUrl += `&ProductShortNames=${encodeURIComponent(device)}`;
      });

      // Make API request
      const response = await fetch(apiUrl);
      
      if (!response.ok) {
        throw new Error(`API request failed: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();

      // Display results
      displayResults(data);

    } catch (error) {
      showError('Unable to fetch store locations. Please try again later.');
    } finally {
      hideLoading();
    }
  }

  function showLoading() {
    const buttonSpan = findButton.querySelector('span');
    if (buttonSpan) {
      buttonSpan.innerHTML = '<span class="loading-spinner"></span>Finding stores...';
    }
    findButton.disabled = true;
  }

  function hideLoading() {
    const buttonSpan = findButton.querySelector('span');
    if (buttonSpan) {
      buttonSpan.textContent = 'Find';
    }
    findButton.disabled = false;
  }

  function showError(message) {
    // Remove any existing error messages
    const existingError = form.querySelector('.error-message');
    if (existingError) {
      existingError.remove();
    }

    // Create and show error message
    const errorDiv = document.createElement('div');
    errorDiv.className = 'error-message';
    errorDiv.textContent = message;
    
    // Insert after the form
    form.parentNode.insertBefore(errorDiv, form.nextSibling);

    // Auto-remove error after 5 seconds
    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 5000);
  }

  function displayResults(data) {
    const resultsContainer = document.getElementById('store-results');
    const storesListContainer = resultsContainer.querySelector('.stores-list');

    if (!data || !Array.isArray(data) || data.length === 0) {
      storesListContainer.innerHTML = '<p>No stores found in your area. Please try a different location.</p>';
      // Initialize empty map centered on Florida
      initializeMap([]);
      resultsContainer.style.display = 'block';
      return;
    }

    // Generate HTML for each store
    const storesHtml = data.map((store, index) => {
      const name = store.name || store.storeName || 'Store';
      const fullAddress = formatFullAddress(store);
      const distance = store.distanceInMiles ? `${store.distanceInMiles.toFixed(1)} miles` : (store.distance ? `${store.distance.toFixed(1)} miles` : '');
      const phoneNumber = store.phoneNumber || store.phone || '';

      return `
        <div class="store-item" data-store-index="${index}">
          <div class="store-top">
            <div class="store-marker-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="27" height="35" viewBox="0 0 27 35" fill="none">
                <path d="M13.5 0.516113C9.94285 0.515934 6.52937 1.92876 4.00147 4.44751C1.47358 6.96627 0.0355715 10.3874 0 13.9673C0 23.2744 11.8969 33.6346 12.4031 34.0761C12.7088 34.3393 13.0978 34.4839 13.5 34.4839C13.9022 34.4839 14.2912 34.3393 14.5969 34.0761C15.1875 33.6346 27 23.2744 27 13.9673C26.9644 10.3874 25.5264 6.96627 22.9985 4.44751C20.4706 1.92876 17.0572 0.515934 13.5 0.516113Z" fill="#014FD3"/>
              </svg>
              <span class="store-marker-number">${index + 1}</span>
            </div>
            <div class="store-content">
              <div class="store-name">${escapeHtml(name)}</div>
              ${distance ? `<div class="store-distance">${distance}</div>` : ''}
              <div class="store-address">${escapeHtml(fullAddress)}</div>
            </div>
          </div>
          <div class="store-bottom">
            ${phoneNumber ? `<a href="tel:${escapeHtml(phoneNumber)}" class="store-phone">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M19.0101 21.5001H18.9601C14.6501 21.2601 10.6001 19.4801 7.53011 16.4801C4.52538 13.4044 2.7382 9.34326 2.50011 5.05006C2.48011 4.30006 2.96011 3.67006 3.66011 3.48006L7.03011 2.60006C7.86011 2.38006 8.75011 2.81006 9.09011 3.60006L10.9001 7.81006C11.1801 8.47006 11.0401 9.22006 10.5401 9.73006L9.35011 10.9401C9.27011 11.0201 9.25011 11.1501 9.31011 11.2401C9.77011 11.9201 10.3001 12.5701 10.8801 13.1701C11.4501 13.7201 12.1101 14.2501 12.7901 14.7201C12.8801 14.7801 13.0001 14.7601 13.0901 14.6801L14.3001 13.4901C14.8101 12.9901 15.5601 12.8501 16.2201 13.1301L20.4301 14.9401C21.2201 15.2801 21.6501 16.1601 21.4301 17.0001L20.5401 20.3701C20.3401 21.0201 19.7101 21.5001 19.0101 21.5001ZM7.47011 4.04006C7.45011 4.04006 7.43011 4.04006 7.41011 4.05006L4.04011 4.94006C4.21011 8.90006 5.84011 12.6101 8.59011 15.4201C11.3901 18.1601 15.1001 19.7901 19.0301 20.0001L19.9501 16.5901C19.9801 16.4701 19.9201 16.3401 19.8101 16.3001L15.6001 14.4901C15.5552 14.4706 15.5056 14.465 15.4575 14.4739C15.4094 14.4828 15.365 14.5058 15.3301 14.5401L14.1201 15.7301C13.5301 16.3101 12.6101 16.4101 11.9301 15.9501C11.1701 15.4401 10.4501 14.8501 9.80011 14.2201C9.15011 13.5401 8.56011 12.8201 8.05011 12.0701C7.59011 11.3901 7.68011 10.4701 8.27011 9.88006L9.46011 8.67006C9.53011 8.60006 9.55011 8.49006 9.51011 8.40006L7.70011 4.19006C7.68209 4.14428 7.65026 4.10524 7.60905 4.07836C7.56784 4.05148 7.51928 4.0381 7.47011 4.04006Z" fill="#014FD3"/>
              </svg>
              ${escapeHtml(phoneNumber)}
            </a>` : '<div></div>'}
            <div class="store-directions">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M17.98 20.5H6.02C4.63 20.5 3.5 19.37 3.5 17.98V6.01999C3.5 4.62999 4.63 3.49999 6.02 3.49999H10.45C10.86 3.49999 11.2 3.83999 11.2 4.24999C11.2 4.65999 10.86 4.99999 10.45 4.99999H6.02C5.46 4.99999 5 5.45999 5 6.01999V17.98C5 18.54 5.46 19 6.02 19H17.98C18.54 19 19 18.54 19 17.98V13.55C19 13.14 19.34 12.8 19.75 12.8C20.16 12.8 20.5 13.14 20.5 13.55V17.98C20.5 19.37 19.37 20.5 17.98 20.5Z" fill="#014FD3"/>
                <path d="M20.44 3.95999C20.36 3.77999 20.22 3.62999 20.03 3.54999C19.94 3.50999 19.84 3.48999 19.74 3.48999H15.31C14.9 3.48999 14.56 3.82999 14.56 4.23999C14.56 4.64999 14.91 4.99999 15.32 4.99999H17.94L11.47 11.47C11.18 11.76 11.18 12.24 11.47 12.53C11.62 12.68 11.81 12.75 12 12.75C12.19 12.75 12.38 12.68 12.53 12.53L19 6.05999V8.67999C19 9.08999 19.34 9.42999 19.75 9.42999C20.16 9.42999 20.5 9.08999 20.5 8.67999V4.24999C20.5 4.14999 20.48 4.05999 20.44 3.95999Z" fill="#014FD3"/>
              </svg>
              Directions
            </div>
          </div>
        </div>
      `;
    }).join('');

    storesListContainer.innerHTML = `
      <h3>Found ${data.length} store${data.length !== 1 ? 's' : ''} near you:</h3>
      ${storesHtml}
    `;

    // Initialize and populate map
    initializeMap(data);

    resultsContainer.style.display = 'block';

    // Scroll to results
    resultsContainer.scrollIntoView({ behavior: 'smooth' });
  }

  function initializeMap(stores) {
    // Set Mapbox access token
    mapboxgl.accessToken = MAPBOX_TOKEN;

    // Clear existing map if it exists
    if (map) {
      map.remove();
      markers = [];
    }

    // Determine which map container to use based on screen size
    const isMobile = window.innerWidth <= 767;
    const mapContainer = isMobile ? 'mobile-map' : 'store-map';
    
    // Make sure the appropriate container is visible
    if (isMobile) {
      document.querySelector('.mobile-map-container').style.display = 'block';
    }

    // Filter stores that have valid coordinates
    const validStores = stores.filter(store => 
      store.latitude && store.longitude && 
      !isNaN(parseFloat(store.latitude)) && !isNaN(parseFloat(store.longitude))
    );

    // Initialize map - either with store bounds or centered on Florida
    if (validStores.length === 0) {
      // No stores found - show empty map centered on Florida
      map = new mapboxgl.Map({
        container: mapContainer,
        style: 'mapbox://styles/mapbox/streets-v12',
        center: [-82.4572, 27.7663], // Florida center coordinates
        zoom: 6 // Show most of Florida
      });
    } else {
      // Calculate center point and bounds for stores
      const bounds = new mapboxgl.LngLatBounds();
      validStores.forEach(store => {
        bounds.extend([parseFloat(store.longitude), parseFloat(store.latitude)]);
      });

      // Initialize map with store bounds
      map = new mapboxgl.Map({
        container: mapContainer,
        style: 'mapbox://styles/mapbox/streets-v12',
        bounds: bounds,
        fitBoundsOptions: {
          padding: 50
        }
      });
    }

    // Add markers for each store
    validStores.forEach((store, index) => {
      const lng = parseFloat(store.longitude);
      const lat = parseFloat(store.latitude);
      
      // Create marker element
      const markerElement = document.createElement('div');
      markerElement.className = 'store-marker';
      markerElement.innerHTML = `
        <div class="marker-pin">
          <svg xmlns="http://www.w3.org/2000/svg" width="27" height="35" viewBox="0 0 27 35" fill="none">
            <path d="M13.5 0.516113C9.94285 0.515934 6.52937 1.92876 4.00147 4.44751C1.47358 6.96627 0.0355715 10.3874 0 13.9673C0 23.2744 11.8969 33.6346 12.4031 34.0761C12.7088 34.3393 13.0978 34.4839 13.5 34.4839C13.9022 34.4839 14.2912 34.3393 14.5969 34.0761C15.1875 33.6346 27 23.2744 27 13.9673C26.9644 10.3874 25.5264 6.96627 22.9985 4.44751C20.4706 1.92876 17.0572 0.515934 13.5 0.516113Z" fill="#014FD3"/>
          </svg>
          <span class="marker-number">${index + 1}</span>
        </div>
      `;

      // Create popup content
      const name = store.name || store.storeName || 'Store';
      const fullAddress = formatFullAddress(store);
      const distance = store.distanceInMiles ? `${store.distanceInMiles.toFixed(1)} miles away` : (store.distance ? `${store.distance.toFixed(1)} miles away` : '');
      const phoneNumber = store.phoneNumber || store.phone || '';

      const popupContent = `
        <div class="store-popup">
          <h4>${escapeHtml(name)}</h4>
          ${distance ? `<p class="distance">${distance}</p>` : ''}
          <p>${escapeHtml(fullAddress)}</p>
          ${phoneNumber ? `<p class="phone">${escapeHtml(phoneNumber)}</p>` : ''}
        </div>
      `;

      // Create popup
      const popup = new mapboxgl.Popup({
        offset: 25,
        closeButton: true,
        closeOnClick: false
      }).setHTML(popupContent);

      // Create and add marker
      const marker = new mapboxgl.Marker(markerElement)
        .setLngLat([lng, lat])
        .setPopup(popup)
        .addTo(map);

      markers.push(marker);

      // Add click handler to store item to highlight marker
      const storeItem = document.querySelector(`[data-store-index="${index}"]`);
      if (storeItem) {
        storeItem.addEventListener('click', () => {
          // Close all popups
          markers.forEach(m => m.getPopup().remove());
          // Open this marker's popup
          marker.getPopup().addTo(map);
          // Fly to marker
          map.flyTo({
            center: [lng, lat],
            zoom: 15,
            duration: 1000
          });
        });
      }
    });

    // Add navigation controls
    map.addControl(new mapboxgl.NavigationControl(), 'top-right');
  }

  function formatAddress(store) {
    const parts = [];
    
    if (store.address || store.streetAddress) {
      parts.push(store.address || store.streetAddress);
    }
    
    if (store.city) {
      parts.push(store.city);
    }
    
    if (store.state || store.stateCode) {
      parts.push(store.state || store.stateCode);
    }
    
    if (store.zipCode || store.postalCode) {
      parts.push(store.zipCode || store.postalCode);
    }

    return parts.join(', ') || 'Address not available';
  }

  function formatFullAddress(store) {
    const parts = [];
    
    // Add address1 and address2
    if (store.address1) {
      parts.push(store.address1);
    }
    
    if (store.address2) {
      parts.push(store.address2);
    }
    
    // Fallback to generic address fields if address1/address2 not available
    if (parts.length === 0 && (store.address || store.streetAddress)) {
      parts.push(store.address || store.streetAddress);
    }
    
    if (store.city) {
      parts.push(store.city);
    }
    
    if (store.state || store.stateCode) {
      parts.push(store.state || store.stateCode);
    }
    
    if (store.zipCode || store.postalCode) {
      parts.push(store.zipCode || store.postalCode);
    }

    return parts.join(', ') || 'Address not available';
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}